import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { RichText } from './TextEditor';
import { withStyles } from '@material-ui/core/styles';

// Based on base input style https://github.com/mui-org/material-ui/blob/18aa6293ad8b67dc8a323db19117c93efa966c7c/packages/material-ui/src/Input/Input.js
export const styles = theme => {
    const light = theme.palette.type === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';

    return {
        focused: {},
        disabled: {},
        underline: {
            borderBottom: `1px solid ${bottomLineColor}`,
            color: '#000',
            borderBottomColor: '200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
            '&:hover:not($disabled):not($focused):not($error)': {
                borderBottom: `2px solid ${theme.palette.text.primary}`,
                marginBottom: '-1px'
            },
            '&:after': {
                borderBottom: `2px solid ${theme.palette.primary[light ? 'dark' : 'light']}`,
                left: 0,
                bottom: 0,
                content: '""',
                position: 'absolute',
                right: 0,
                transform: 'scaleX(0)',
                transition: theme.transitions.create('transform', {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: 'none'
            },
            '&$focused:after': {
                transform: 'scaleX(1)'
            },
            '&$error:after': {
                borderBottomColor: theme.palette.error.main,
                transform: 'scaleX(1)'
            },
            '&:before': {
                borderBottom: `1px solid ${bottomLineColor}`,
                left: 0,
                bottom: 0,
                content: '"\\00a0"',
                position: 'absolute',
                right: 0,
                transition: theme.transitions.create('border-bottom-color', {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: 'none'
            },
            '&:hover:not($disabled):not($focused):not($error):before': {
                borderBottom: `2px solid ${theme.palette.text.primary}`
            },
            '&$disabled:before': {
                borderBottom: `1px dotted ${bottomLineColor}`
            }
        },
        error: {}
    };
};

class MaterialTextEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFocused: false
        };
    }
    handleOnFocus = isFocused => {
        this.setState({ isFocused });
    };
    render = () => {
        const classNames = cx({
            [this.props.classes.underline]: true,
            [this.props.classes.focused]: this.state.isFocused //this.state.isFocused
        });
        return (
            <div>
                <RichText
                    slot={this.props.slot}
                    placeholder={this.props.placeholder}
                    content={this.props.content}
                    simpleMode={this.props.simpleMode}
                    className={classNames}
                    onChange={this.props.onChange}
                    modalPrompt={this.props.modalPrompt}
                    onFocused={this.handleOnFocus}
                />
            </div>
        );
    };
}

MaterialTextEditor.propTypes = {
    slot: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    content: PropTypes.string,
    simpleMode: PropTypes.bool,
    classes: PropTypes.object,

    onChange: PropTypes.func.isRequired,
    modalPrompt: PropTypes.func
};

export default withStyles(styles)(MaterialTextEditor);
